import local from "../../utils/localStroage";

const AppsStorageKey = "AppsStorageKey";
export const apps = local.get(AppsStorageKey) || [];

export const updateApps = (newApps) => {
  apps.splice(0);
  Object.assign(apps, newApps);
  local.set(AppsStorageKey, newApps);
};
